<template>
    <div>
        <!-- [ Modal form Save Task Tree ] start -->
        <sweet-modal blocking ref="projectExpenseModal" class="project-expense-modal" v-on:close="closeModal">
            <h1 v-if='!ifEdit' class="project-expense-modal__title">Request Expense</h1>
            <h1 v-else class="project-expense-modal__title">Edit Expense</h1>
            <el-form :model="form" status-icon :rules="rules" ref="form" label-position="right" class="project-expense-modal__form">
                <div>
                    <div>
                        <el-col class="col" :span="12">
                            <el-form-item label-width="130px" v-if="ifEdit" label="Expense No.">
                                <el-input disabled v-model="codeNo" filterable size="mini" placeholder="Expense No.">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </div>
                    <el-row v-if="selectedRow">
                        <el-col :span="12">
                            <el-form-item label-width="130px" v-if="selectedRow.type === 'project' || selectedRow.type === 'Engagement'" prop="projectListName" :label="labelName">
                                <el-select disabled v-model="selectedRow.name" size="mini" :placeholder="labelName">
                                    <el-option v-for="item in form.projectList"
                                               filterable
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  label-width="130px" prop="projectListName" v-if="selectedRow.type === 'task' || selectedRow.type === 'Task' || selectedRow.type === 'masterTask'" label="Project">
                                <el-select disabled v-model="selectedProject.name" size="mini" placeholder="Task">
                                    <!--<el-option v-for="item in form.taskList"-->
                                    <!--:key="item.id"-->
                                    <!--:label="item.name"-->
                                    <!--:value="item.id">-->
                                    <!--</el-option>-->
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item  label-width="130px" prop="taskListName" v-if="selectedRow.type === 'task' || selectedRow.type === 'Task' || selectedRow.type === 'masterTask'" label="Task">
                                <el-select disabled v-model="selectedRow.name" size="mini" placeholder="Task">
                                    <el-option v-for="item in form.taskList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label-width="130px" v-if="selectedRow.type === 'project' || selectedRow.type === 'Engagement'" prop="taskListId" label="Task">
                                <el-select v-model="form.taskListId" clearable size="mini" placeholder="Task">
                                    <el-option v-for="item in form.taskList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id"
                                               @click.native="setTaskId(item.id)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <div>
                    <el-row v-if="fromExpensePage === true">
                        <el-col :span="12">
                            <el-form-item label-width="130px" prop="projectListId" :label="labelName">
                                <el-select v-model="form.projectListId" size="mini" :placeholder="labelName">
                                    <el-option v-for="item in form.projectList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id"
                                               @click.native="setProject(item.id, false, false, false, activeState)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item  label-width="130px" prop="taskListId" label="Task">
                                <el-select clearable :disabled="disabledTask" v-model="form.taskListId" size="mini" placeholder="Task">
                                    <el-option v-for="item in form.taskList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id"
                                               @click.native="setTask(item.id, false, activeState)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="ifEdit === true">
                        <el-col :span="12">
                            <el-form-item label-width="130px" prop="projectListIdEdit" label="Project 1">
                                <el-select disabled v-model="form.projectListIdEdit" size="mini" placeholder="Project">
                                    <el-option v-for="item in form.projectList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id"
                                               @click.native="setProject(item.id, false, false, false, activeState)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item  label-width="130px" prop="taskListIdEdit" label="Task">
                                <el-select  clearable v-model="form.taskListIdEdit" size="mini" placeholder="Task">
                                    <el-option v-for="item in form.taskList"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id"
                                               @click.native="setTask(item.id, false, activeState)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <el-row>
                    <!--<el-col :span="12">-->
                        <!--<el-form-item prop="companyInventoryItemId" label="Expense Item">-->
                            <!--<el-select :disabled="disabledInputs" v-model="form.companyInventoryItemId" filterable size="mini" placeholder="Expense Item">-->
                                <!--<el-option-->
                                        <!--v-for="item in form.companyInventoryItem"-->
                                        <!--:key="item.id"-->
                                        <!--:label="item.name"-->
                                        <!--:value="item.id">-->
                                <!--</el-option>-->
                            <!--</el-select>-->
                        <!--</el-form-item>-->
                    <!--</el-col>-->
                    <!--{{form.vendorListId}}-->
                    <el-col :span="12">
                        <!--<el-form-item prop="vendorListId" label="Vendor Name">-->
                        <!--<el-select filterable-->
                        <!--:disabled="disabledInputs"-->
                        <!--v-model="form.vendorListId"-->
                        <!--size="mini"-->
                        <!--placeholder="Vendor Name">-->
                        <!--<el-option-->
                        <!--v-for="item in form.vendorList"-->
                        <!--:key="item.id"-->
                        <!--:label="item.name"-->
                        <!--:value="item.id">-->
                        <!--</el-option>-->
                        <!--</el-select>-->
                        <!--</el-form-item>-->
                        <!--{{form.vendorListId}}-->
                        <!--{{form.vendorListId}}<br>-->
                        <!--{{form.vendorListInput}}-->
                        <!--{{form.vendorList}}<br>-->
                        <!--{{form.vendorListInput}}-->
                        <!--{{form.vendorListInput}}-->
                        <!--{{form.vendorListInput}}-->
                        <el-form-item label-width="130px" prop="vendorListInput" label="Vendor Name">
                            <el-autocomplete
                                    :disabled="disabledInputs"
                                    popper-class="my-autocomplete"
                                    v-model="form.vendorListInput"
                                    size="mini"
                                    :fetch-suggestions="querySearch"
                                    placeholder="Vendor Name"
                                    @select="handleSelect">
                                <!--<el-button slot="append" icon="el-icon-search"></el-button>-->
                                <el-button
                                        class="add-btn"
                                        v-if="isEmpty"
                                        size="mini"
                                        type="primary"
                                        slot="append"
                                        pain
                                        @click="handleIconClickVendor">Add</el-button>
                                <template slot-scope="{ item }">
                                    <div class="value">{{ item.name }}</div>
                                </template>
                            </el-autocomplete>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label-width="130px" label="Payment Methods">
                            <el-radio :disabled="disabledInputs" v-model="paymentMethodRadio" label="Payment">Payment</el-radio>
                            <el-radio :disabled="disabledInputs" v-model="paymentMethodRadio" label="CA">Cash Advance</el-radio>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!--{{form.date}}-->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label-width="130px" label="Expense Date" prop="date">
                            <el-date-picker
                                    format="d MMM yy"
                                    :disabled="disabledInputs"
                                    size="mini"
                                    v-model="form.date"
                                    type="date"
                                    placeholder="Pick a date"
                                    value-format="ddMMyyyy"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label-width="130px" prop="reimbursable" label="">
                            <el-checkbox :disabled="disabledInputs" name="type" v-model="form.reimbursable">Reimbursable</el-checkbox>
                        </el-form-item>
                        <el-form-item label-width="130px" prop="billable" label="">
                            <el-checkbox :disabled="disabledInputs" name="type" v-model="form.billable">Billable</el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <div>
                            <el-form-item label-width="130px" v-if="paymentMethodRadio === 'Payment'" prop="paymentMethodId" label="Payment">
                                <el-select :disabled="disabledInputs" v-model="form.paymentMethodId" size="mini" placeholder="Payment Method">
                                    <el-option
                                            v-for="item in form.paymentMethodList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label-width="130px" v-if="paymentMethodRadio === 'CA'"  prop="cashAdvanceId" label="Cash Advance">
                                <el-select :disabled="disabledInputs" type="number" v-model="form.cashAdvanceId" size="mini" placeholder="Cash Advance">
                                    <el-option
                                            v-for="item in form.cashAdvanceList"
                                            :key="item.id"
                                            :label="item.code + '   ' + formatPrice(item.amount)"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label-width="130px" v-if="paymentMethodRadio === 'CA'">
                                <el-button :disabled="disabledInputs" @click="createAdvance(activeState)" size="mini">Request Advance</el-button>
                            </el-form-item>
                            <!--{{form.ifTax}}-->
                        </div>
                    </el-col>
                    <!--<el-col :span="12">-->
                        <!--<el-form-item label="Payment Methods">-->
                            <!--<el-radio :disabled="disabledInputs" v-model="paymentMethodRadio" label="Payment">Payment</el-radio>-->
                            <!--<el-radio :disabled="disabledInputs" v-model="paymentMethodRadio" label="CA">Cash Advance</el-radio>-->
                        <!--</el-form-item>-->
                    <!--</el-col>-->
                </el-row>
                <!--<el-row>-->
                    <!--<el-col :span="12">-->
                        <!--<el-row>-->
                            <!--<el-col :span="24">-->
                                <!--<div class="amount-input">-->
                                    <!--<el-form-item   prop="amount" label="Amount">-->
                                        <!--&lt;!&ndash;{{projectTaxId}}{{form.amount}}{{form.taxId}}&ndash;&gt;-->
                                        <!--<el-input @mouseleave.native="getTotalAmount(projectTaxId || form.taxId, form.amount)" @change="getTotalAmount(projectTaxId || form.taxId, form.amount)" :disabled="disabledInputs" type="number" v-model="form.amount" size="mini" placeholder="Amount"></el-input>-->
                                    <!--</el-form-item>-->
                                <!--</div>-->
                            <!--</el-col>-->
                        <!--</el-row>-->
                        <!--<el-form-item prop="reimbursable" label="">-->
                            <!--<el-checkbox :disabled="disabledInputs" name="type" v-model="form.reimbursable">Reimbursable</el-checkbox>-->
                        <!--</el-form-item>-->
                        <!--<el-form-item prop="billable" label="">-->
                            <!--<el-checkbox :disabled="disabledInputs" name="type" v-model="form.billable">Billable</el-checkbox>-->
                        <!--</el-form-item>-->
                        <!--<el-form-item prop="isCashAdvance" label="">-->
                            <!--<el-checkbox @change="turnOnCashAdvance" :disabled="disabledInputs" name="type" v-model="form.isCashAdvance">Cash Advance</el-checkbox>-->
                        <!--</el-form-item>-->
                        <!--{{form.billable}}-->
                    <!--</el-col>-->
                    <!--{{form.ifTax}}-->
                    <!--<el-col :span="12">-->
                        <!--<div>-->
                            <!--<el-form-item v-if="paymentMethodRadio === 'Payment'" prop="paymentMethodId" label="Payment">-->
                                <!--<el-select :disabled="disabledInputs" v-model="form.paymentMethodId" size="mini" placeholder="Payment Method">-->
                                    <!--<el-option-->
                                            <!--v-for="item in form.paymentMethodList"-->
                                            <!--:key="item.id"-->
                                            <!--:label="item.name"-->
                                            <!--:value="item.id">-->
                                    <!--</el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item v-if="paymentMethodRadio === 'CA'"  prop="cashAdvanceId" label="Cash Advance">-->
                                <!--<el-select :disabled="disabledInputs" type="number" v-model="form.cashAdvanceId" size="mini" placeholder="Cash Advance">-->
                                    <!--<el-option-->
                                            <!--v-for="item in form.cashAdvanceList"-->
                                            <!--:key="item.id"-->
                                            <!--:label="item.code + '   ' + formatPrice(item.amount)"-->
                                            <!--:value="item.id">-->
                                    <!--</el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->

                            <!--<el-form-item v-if="paymentMethodRadio === 'CA'">-->
                                <!--<el-button :disabled="disabledInputs" @click="createAdvance(activeState)" size="mini">Request Advance</el-button>-->
                            <!--</el-form-item>-->
                            <!--&lt;!&ndash;{{form.ifTax}}&ndash;&gt;-->
                        <!--</div>-->
                    <!--</el-col>-->
                <!--</el-row>-->
                <el-divider></el-divider>
                <el-row :gutter="20" :span="24">
                    <el-col :span="7">
                        <el-form-item  label-position="top" prop="companyInventoryItemId" label="Expense Item">
                            <el-select :disabled="disabledInputs" v-model="form.companyInventoryItemId" filterable size="mini" placeholder="Expense Item">
                                <el-option
                                        v-for="item in form.companyInventoryItem"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <!--{{taxObject}}-->
                         <el-form-item   label-position="top" prop="amount" label="Amount">
                                <!--{{projectTaxId}}{{form.amount}}{{form.taxId}}-->
                                <el-input @mouseleave.native="getTotalAmount(projectTaxId || form.taxId, form.amount, taxObject)" @change="getTotalAmount(projectTaxId || form.taxId, form.amount, taxObject)" :disabled="disabledInputs" type="number" v-model="form.amount" size="mini" placeholder="Amount"></el-input>
                         </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item  label-position="top" label="Tax Amount">
                            <el-button  plain size="mini" type="primary" >{{formatPrice(totalTax)}}</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label-position="top" label="Total Amount">
                            <el-button  plain size="mini" type="primary" >{{formatPrice(totalAmaunt)}}</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label-width="130px" prop="taxId" label="Tax">
                            <el-select :disabled="disabledInputs" type="number" v-model="form.taxId" size="mini" placeholder="Tax">
                                <el-option
                                        v-for="item in form.taxList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="getTotalAmount(item.id, form.amount, item)">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label-width="130px" prop="resource">
                            <el-radio-group @change="getTotalAmount(projectTaxId || form.taxId, form.amount)" v-model="form.ifTax">
                                <el-radio :disabled="disabledInputs" label="Tax Exclusive"></el-radio>
                                <el-radio :disabled="disabledInputs" class="inclusive-btn" label="Tax Inclusive"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label-width="130px" prop="clientId" label="Client">
                            <el-select :disabled="disabledInputs" v-model="form.clientId" filterable size="mini" placeholder="Client">
                                <el-option
                                        v-for="item in form.clientList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label-width="130px" prop="groupTripName" label="Group / Trip Name">
                            <el-input :disabled="disabledInputs" v-model="form.groupTripName" size="mini" placeholder="Group / Trip Name"></el-input>
                        </el-form-item>
                    </el-col>
                    <!--<el-col :span="12">-->
                        <!--<el-form-item label="Total Amount :">-->
                            <!--<el-button  size="mini" type="primary" >{{formatPrice(totalAmaunt)}}</el-button>-->
                        <!--</el-form-item>-->
                    <!--</el-col>-->
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label-width="130px" prop="vendorTaxNumber" label="Vendor Tax Number">
                            <el-input :disabled="disabledInputs" v-model="form.vendorTaxNumber" size="mini" placeholder="Vendor Tax Number"></el-input>
                        </el-form-item>
                    </el-col>
                    <!--<el-col :span="12">-->
                        <!--<el-form-item prop="groupTripName" label="Group / Trip Name">-->
                            <!--<el-input :disabled="disabledInputs" v-model="form.groupTripName" size="mini" placeholder="Group / Trip Name"></el-input>-->
                        <!--</el-form-item>-->
                    <!--</el-col>-->
                </el-row>
                <!--<el-row>-->
                    <!--<el-col :span="12">-->
                        <!--<el-form-item prop="taxId" label="Tax">-->
                            <!--<el-select :disabled="disabledInputs" type="number" v-model="form.taxId" size="mini" placeholder="Tax">-->
                                <!--<el-option-->
                                        <!--v-for="item in form.taxList"-->
                                        <!--:key="item.id"-->
                                        <!--:label="item.name"-->
                                        <!--:value="item.id"-->
                                        <!--@click.native="getTotalAmount(item.id, form.amount)">-->
                                <!--</el-option>-->
                            <!--</el-select>-->
                        <!--</el-form-item>-->
                    <!--</el-col>-->
                    <!--<el-col :span="12">-->
                        <!--<el-form-item prop="resource">-->
                            <!--<el-radio-group @change="getTotalAmount(projectTaxId || form.taxId, form.amount)" v-model="form.ifTax">-->
                                <!--<el-radio :disabled="disabledInputs" class="inclusive-btn" label="Tax Inclusive"></el-radio>-->
                                <!--<el-radio :disabled="disabledInputs" label="Tax Exclusive"></el-radio>-->
                            <!--</el-radio-group>-->
                        <!--</el-form-item>-->
                    <!--</el-col>-->
                <!--</el-row>-->
                <el-row>
                    <el-form-item label-width="130px" label="Notes" prop="notes">
                        <el-input :disabled="disabledInputs" type="textarea" v-model="form.notes"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>

                </el-row>
                <el-row>
                    <addFileToExpence :fileListEdit="fileListEdit" :disabledInputs="disabledInputs" ref="addFileToExpence" :selectedRow="selectedRow" @nestedChildOpen="nestedChildOpen" @putFileIntoFormArray="putFileIntoFormArray" @removeFile="removeFile" />
                </el-row>
                <div class="project-expense-modal__btn">
                    <!--<el-button @click="getCurrency">CLICK</el-button>-->
                    <el-button v-if="ifEdit === false" :disabled="disabledInputs" @click="submitForm('form', activeState)" type="primary" plain size="mini">Save</el-button>
                    <el-button v-else :disabled="disabledInputs" @click="submitFormEdit('form', activeState)" type="primary" plain size="mini">Edit</el-button>
                </div>
            </el-form>
            <!--{{form.fileId}}-->
        </sweet-modal>
        <!-- <sweet-modal class="nested" ref="nestedChild">
            <iframe class="iframe" :src="'https://docs.google.com/gview?url=' + fileUrl + '&embedded=true'" frameborder="0"></iframe>
        </sweet-modal> -->
        <!-- [ Modal form Save Task Tree ] end -->
        <AddVendorForm ref="modal11" :directories="directories" v-model="form.vendorListInput" @setTask="setTask"/>

        <!--REQUEST CASH ADVANCE ADD EDIT MODAL START-->
        <requestProjectCashAdvanceModal
                @setCashAdvanceAfterCreate='setCashAdvanceAfterCreate'
                :selectedRow="selectedRowForModal"
                ref="requestProjectCashAdvanceModal"/>
        <!--REQUEST CASH ADVANCE ADD EDIT MODAL END-->

    </div>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import axios from 'axios'
  let moment = require('moment')
  import addFileToExpence from '@/components/Projects/addFileToExpence.vue'
  import AddVendorForm from '@/components/vendors/AddVendorForm.vue'
  import requestProjectCashAdvanceModal from '@/components/Projects/requestProjectCashAdvanceModal.vue'


  export default {
    components: {
      SweetModal,

      addFileToExpence,
      AddVendorForm,
      requestProjectCashAdvanceModal
    },
    props: ['projectExpenseModal', 'selectedRow', 'valueProject', 'projectName'],
    data() {
      return {
        paymentMethodRadio: 'Payment',
        codeNo: '',
        totalAmaunt: '0',
        taxObject: '',
        totalTax: '',
        taxAmount: '',
        projectTaxId: '',
        selectedTaskId: '',
        isEmpty:false,
        ifEdit:false,
        selectedProjectId: '',
        disabledInputs:true,
        disabledTask:true,
        moment:moment,
        projectTaskExpenseId: '',
        countingAmount: false,
        selectedProject: {},
        form: {
          projectListIdEdit:'',
          projectListId:this.selectedRow.name,
          projectList:[],
          taskListIdEdit: '',
          taskListId: '',
          taskList: [],
          companyInventoryItemId: '',
          companyInventoryItem: [],
          vendorList: [],
          vendorListInput: '',
          vendorListId: '',
          date:'',
          paymentMethodId: '',
          paymentMethodList: [],
          amount: '',
          // amountId: '',
          // amountList: [],
          taxId: '',
          taxList:[],
          reimbursable: false,
          billable: false,
          // isCashAdvance: false,
          cashAdvanceList:[],
          cashAdvanceId:'',
          ifTax: 'Tax Exclusive',
          clientId: '',
          clientList: [],
          vendorTaxNumber: '',
          groupTripName: '',
          notes: '',
          fileId: null
        },
        directories:null,
        fromExpensePage:false,
        fileUrl: '',
        fileListEdit:[],
        links: [],
        // state: '',
        rules: {
          companyInventoryItemId: [{
            required: true,
            message: 'Field is required',
            trigger: 'blur'
          }],
          amount: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          taxId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          vendorListInput: [
            { required: true,
              message: 'Field is required',
              trigger: 'change' }
          ],
          date: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          paymentMethodId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          // taskListId: [
          //   { required: true,
          //     message: 'Field is required',
          //     trigger: 'blur' }
          // ],
          clientId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          cashAdvanceId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          // vendorTaxNumber:[
          //   { required: true,
          //     message: 'Field is required',
          //     trigger: 'blur' }
          // ],
          // groupTripName:[
          //   { required: true,
          //     message: 'Field is required',
          //     trigger: 'blur' }
          // ],
          notes:[
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ],
          projectListId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ]
        },
        activeState:'',
        labelName: '',
        selectedRowForModal: {}
      }
    },
    // mounted(){
    //   this.links = this.loadAll();
    // },
    methods: {
      setTaskId(taskId){
        this.selectedTaskId = taskId
      },
      getCurrency(){
        // let _axios = axios
        // _axios.defaults.headers.common = 0;
        // _axios
        //   .get(`https://free.currconv.com/api/v7/currencies?apiKey=16efddfda704e39960f0`).then(response => {
        //   this.form.amountList = response.data.results
        //   _axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        //   _axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // }).catch(error => {
        //   console.log('An error occurred:', error);
        //   loader.hide()
        // })

      },
      createAdvance(state){
        const urlParts = this.buildUrl(state)
        //Create CA from exp page
        if(this.$route.name === 'expenses' && this.form.taskListId || this.$route.name === 'users' && this.form.taskListId){
          this.form.taskList.forEach(val => {
            if(val.id === this.form.taskListId){
              this.selectedRowForModal = val
              this.selectedRowForModal.type = 'task'
              setTimeout(()=>{
                this.$refs['requestProjectCashAdvanceModal'].openModal(urlParts.cashAdvanceState, this.form.projectListId)
              }, 500)
            }
          })
        //Create CA from projectPage/BU/ENG
        }else if(this.$route.name === 'projects' || this.$route.name === 'business-units' || this.$route.name === 'engagements'){
          this.selectedRowForModal = this.selectedRow
          setTimeout(()=>{
            this.$refs['requestProjectCashAdvanceModal'].openModal(urlParts.cashAdvanceState, this.$route.query.projectId || this.$route.query.businessUnitId || this.$route.query.engagementId )
          }, 500)
        }else if(this.$route.name === 'expenses' && !this.form.taskListId || this.$route.name === 'users' && !this.form.taskListId){
          this.$refs['requestProjectCashAdvanceModal'].openModal(urlParts.cashAdvanceState, this.form.projectListId)
        }
      },
      putFileIntoFormArray(fileId){
        // this.form.fileId.push(fileId)
        this.form.fileId = fileId
      },
      openModalFromExpense(state){
        const urlParts = this.buildUrl(state)
        this.activeState = state
        this.labelName = urlParts.labelName
        this.ifEdit = false
        this.fromExpensePage = true
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.routeName}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.form.projectList = response.data.list
            this.$refs.projectExpenseModal.open()
          }).catch(error =>{

        })
      },
      openModalFromExpenseEdit(selectedRow, state){

        this.activeState = state
        const urlParts = this.buildUrl(state)
        // console.log('const urlParts', urlParts)
        this.labelName = urlParts.labelName

        this.ifEdit = true
        this.disabledInputs = false

        // console.log(selectedRow)

        // PROJECT ACTIVE
        if(state === 'requestProjectTaskExpenses'){
          this.selectedProjectId = selectedRow.projectId
          this.form.projectListIdEdit = selectedRow.project.name

          if(!selectedRow.projectTaskId){
            this.form.taskListIdEdit = ''
          }else{
            this.form.taskListIdEdit = selectedRow.projectTaskId
          }
        }
        // ENGAGEMENT ACTIVE
        else if (state === 'requestEngagementTaskExpenses'){
          this.selectedProjectId = selectedRow.engagementId
          this.form.projectListIdEdit = selectedRow.engagement.name

          if(!selectedRow.engagementTaskId){
            this.form.taskListIdEdit = ''
          }else{
            this.form.taskListIdEdit = selectedRow.engagementTaskId
          }
        }
        // BU ACTIVE
        else if (state === 'requestBusinessUnitTaskExpenses'){
          this.selectedProjectId = selectedRow.businessUnitId
          this.form.projectListIdEdit = selectedRow.businessUnit.name

          if(!selectedRow.businessUnitTaskId){
            this.form.taskListIdEdit = ''
          }else{
            this.form.taskListIdEdit = selectedRow.businessUnitTaskId
          }
        }
        console.log('projectId, projectTaskId, expenseId, operation, state', selectedRow.engagementId, selectedRow.engagementTaskId, selectedRow.id)

        this.setProject(selectedRow.projectId || selectedRow.engagementId || selectedRow.businessUnitId,
          selectedRow.projectTaskId || selectedRow.engagementTaskId || selectedRow.businessUnitTaskId,
          selectedRow.id,
          'update', state)
        // this.setTask(selectedRow.projectTaskId)
        this.$refs.projectExpenseModal.open()
      },
      find(array, value) {
        console.log(array, value)
        for (var i = 0; i < array.length; i++) {
          console.log(array[i].id + '/' + value)
          if (array[i].id == value) return true;
        }
        return false
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      setProject(projectId, projectTaskId, expenseId, operation, state){
        this.form.cashAdvanceId = ''
        if(!projectTaskId) projectTaskId = '0'
        const urlParts = this.buildUrl(state)
        this.selectedProjectId = projectId
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.stateProjectTasks}/list?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}`)
          .then(response => {
            // if(response.data.list.length !== 0){
            //   this.disabledTask = false
            //   var index = this.find(response.data.list, this.form.taskListId);
            //   if(!index){
            //     this.form.taskListId = ''
            //   }
            // }else{
            //   this.disabledTask = true
            //   this.disabledInputs = true
            //   this.$refs['form'].resetFields();
            //   this.notification("Notification", "Project without tasks", "info")
            // }
            if(operation === 'update'){
              this.setTask('0', false, this.activeState).then(data => {
                if (data === 'done') this.getItem(projectId, projectTaskId, expenseId, this.activeState)
              })
            }else{
              this.setTask('0', false, this.activeState)
            }
            this.disabledTask = false
            var index = this.find(response.data.list, this.form.taskListId);
            if(!index){
              this.form.taskListId = ''
            }
            this.form.taskList = response.data.list
          }).catch(error =>{

        })
      },
      getDirectories(){

      },
      setTask(id, newVendor, state){
        const urlParts = this.buildUrl(state)
        return new Promise ((resolve, revect) =>{
          if(newVendor){
            this.isEmpty = false
            this.form.vendorListInput = newVendor.name
            this.form.vendorListId = newVendor.id
          }
          this.selectedTaskId = id
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${urlParts.state}/directories?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${this.selectedProjectId || this.$route.query.projectId}&${urlParts.stateTaskId}=${id || this.$route.query.projecTaskId}&operation=create`)
            .then(response => {
              // alert(response.data.projectTaskCashAdvance)
              this.form.paymentMethodList = response.data.projectTaskExpensePaymentMethod
              this.form.companyInventoryItem = response.data.companyInventoryItem
              this.form.clientList = response.data.companyClientList
              // this.form.vendorList = response.data.companyVendorList
              this.form.taxList = response.data.projectTaxList
              this.form.cashAdvanceList = response.data.projectTaskCashAdvance
              this.links = response.data.companyVendorList
              this.disabledInputs = false
              loader.hide()
              resolve('done')
            }).catch(error =>{
            loader.hide()
          })
        })
      },
      getItem(projectId, projectTaskId, projectTaskExpenseId, state){
        const urlParts = this.buildUrl(state)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.state}/item?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}&${urlParts.stateTaskId}=${projectTaskId}&${urlParts.stateExpenseId}=${projectTaskExpenseId}`)
          .then(response => {
            this.projectTaskExpenseId = response.data.item.id
            let date = response.data.item.expenseDate.toString()
            if (date.length < 8) {
              date = '0' + date
            }

            //CHECK PAYMENT METHOD
            if(response.data.item.projectTaskCashAdvanceId !== null){
              this.paymentMethodRadio = 'CA'
              this.form.cashAdvanceId = response.data.item.projectTaskCashAdvanceId
            }else if (response.data.item.projectTaskExpensePaymentMethodId !== null){
              this.paymentMethodRadio = 'Payment'
              this.form.paymentMethodId = response.data.item.projectTaskExpensePaymentMethodId
            }


            if(response.data.item.reimbursable === 1){
              this.form.reimbursable = true
            }else if(response.data.item.reimbursable === 1){
              this.form.reimbursable = false
            }
            if(response.data.item.isBillable === 1){
              this.form.billable = true
            }else if(response.data.item.isBillable === 1){
              this.form.billable = false
            }
            if(response.data.item.includeTax === 0){
              this.form.ifTax = 'Tax Exclusive'
            }else if(response.data.item.includeTax === 0){
              this.form.ifTax = 'Tax Inclusive'
            }
            // this.form.projectListId = response.data.item.projectId
            this.form.taskListId = response.data.item.projectTaskId
            this.form.companyInventoryItemId = response.data.item.projectTaskExpenseInventoryItemId
            this.form.vendorListId = response.data.item.companyVendorId
            console.log('links', this.links)
            this.links.forEach(val => {
              if(val.id === this.form.vendorListId){
                this.form.vendorListInput = val.name
              }
            })
            this.form.clientId = response.data.item.companyClientId
            this.form.date = date
            this.form.amount = response.data.item.amount
            this.totalAmaunt = response.data.item.totalAmount
            this.totalTax = response.data.item.taxAmount
            this.form.taxId = response.data.item.projectTaxId
            // this.form.ifTax = response.data.item.includeTax
            // this.form.reimbursable = response.data.item.reimbursable
            this.form.vendorTaxNumber = response.data.item.vendorTaxNo
            this.form.groupTripName = response.data.item.group
            this.form.notes = response.data.item.notes
            // this.form.billable = response.data.item.isBillable
            this.form.fileId = response.data.item.fileId
            this.codeNo = response.data.item.code
            console.log('form.vendorList', this.links)
            this.form.vendorList.forEach(val => {
              if(val.id == response.data.item.companyVendorId){
                this.form.vendorListInput = val.name
              }
            })
            // this.getTotalAmount(this.form.taxId, this.form.amount)
            if(response.data.item){
              let newFileItem = {
                id: '',
                name: '',
                url: ''
              }
              newFileItem.id = response.data.item.file.id
              newFileItem.name = response.data.item.file.baseName
              newFileItem.url = response.data.item.file.url
              this.fileListEdit.push(newFileItem)
            }

          }).catch(error =>{

        })
      },
      querySearch(queryString, cb) {
        console.log(queryString, {cb})
        var links = this.links;
        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
        // call callback function to return suggestion objects
        console.log(results)

        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if(results.length < 1){
            this.isEmpty = true
            this.form.vendorListId = ''
          }else{
            this.isEmpty = false
          }
          results.forEach(val => {
            if(val.name !== queryString){
              this.isEmpty = true
            }else if(val.name == queryString){
              this.isEmpty = false
            }
          })
          if(this.form.vendorListInput === ''){
            this.isEmpty = false
          }
          console.log('results', results)
          cb(results);
        }, 500 * Math.random());
      },
      createFilter(queryString) {
        return (link) => {
          return (link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      loadAll() {
        return [
          { "value": "vue"},
          { "value": "element" },
          { "value": "cooking" },
          { "value": "mint-ui" },
          { "value": "vuex" },
          { "value": "vue-router" },
          { "value": "babel" }
        ];
      },
    setCashAdvanceAfterCreate(createdCAId){
        this.form.cashAdvanceId = createdCAId
        const urlParts = this.buildUrl(this.activeState)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.state}/directories?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${this.$route.query.projectId || this.$route.query.engagementId || this.$route.query.businessUnitId || this.selectedProjectId}&${urlParts.stateTaskId}=0&operation=create`)
          .then(response => {
            this.form.cashAdvanceList = response.data.projectTaskCashAdvance
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      handleSelect(item) {
        this.form.vendorListInput = item.name
        this.form.vendorListId = item.id
        this.isEmpty = false
        console.log(item);
      },
      handleIconClickVendor(ev) {
        console.log(ev);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyVendors/directories?companyId=${this.$route.query.companyId}&operation=create`)
          .then(response => {
            console.log('---/companyVendors/directories', response.data);
            this.$refs['modal11'].$refs['addVendorForm'].open()
            this.$refs['modal11'].selectedTaskId = this.selectedTaskId
            this.directories = response.data
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      // turnOffCashAdvance(){
      //   this.form.isCashAdvance = false
      //   this.form.cashAdvanceId = ''
      // },
      // turnOnCashAdvance(){
      //   this.form.reimbursable = false
      //   this.form.billable = false
      // },
      getTotalAmount(projectTaxId, taxAmount, taxObject){
        console.log('projectTaxId', projectTaxId, 'Amount', taxAmount, 'taxObject', taxObject)
        //SAVE TAX VALUE
        if(taxObject){
          this.taxObject = taxObject
        }
        if(this.taxObject){
          this.totalTax = this.countTaxAmount(this.taxObject.value, taxAmount)
          console.log(this.totalTax)
        }
        this.countingAmount = true
        if(!projectTaxId && !taxAmount && !taxObject){
          this.countingAmount = false
          this.totalAmaunt = '0'
          this.totalTax = '0'
          return
        }
        if(projectTaxId){
          this.projectTaxId = projectTaxId
        }else if(!projectTaxId){
          this.totalAmaunt = taxAmount
          this.countingAmount = false
          return
        }
        if(taxAmount.toString()){
          this.taxAmount = taxAmount
        }else if (!taxAmount){
          this.taxAmount = '0'
          this.countingAmount = false
          return
        }
        //REQUEST
        let data = {
          projectTaxId: this.projectTaxId,
          amount: this.taxAmount,
          includeTax: ''
        }
        if(this.form.ifTax === 'Tax Inclusive'){
          data.includeTax = true
        }else{
          data.includeTax = false
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/projectTaskExpenses/getTotalAmount?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId || this.selectedProjectId || this.$route.query.engagementId}&projectTaskId=${this.selectedRow.id || this.selectedTaskId || 0}`, data)
          .then(response => {
            console.log('---/projectTaskExpenses/directories', response.data);
            this.countingAmount = false
            function roundUp(num, precision) {
              precision = Math.pow(100, precision)
              return Math.ceil(num * precision) / precision
            }
            this.totalAmaunt = roundUp(response.data.totalAmount, 1)
          })
          .catch(error => {
            this.countingAmount = false
            console.log('An error occurred:', error);
          });
      },
      countTaxAmount(percentages, taxAmount){
        console.log('percentages', percentages, 'taxAmount', taxAmount)
        if(percentages && taxAmount){
          return(Number(taxAmount)/100)*Number(percentages)
        }else {
          return '0'
        }
      },
      closeModal() {
        this.$refs['form'].resetFields();
        this.disabledInputs = true,
          this.$refs['addFileToExpence'].fileList = []
          this.form.projectListIdEdit = '',
          this.form.projectList = [],
          this.form.taskListIdEdit = '',
          this.form.taskListId = '',
          this.form.taskList = [],
          this.form.companyInventoryItemId = '',
          this.form.companyInventoryItem = [],
          this.form.vendorList = [],
          this.form.vendorListId = '',
          this.form.date = '',
          this.form.paymentMethodId =  '',
          this.form.paymentMethodList = [],
          this.form.amount = '',
          this.form.taxId = '',
          this.form.taxList = [],
          this.form.reimbursable = false,
          this.form.billable = false,
          this.form.ifTax = 'Tax Exclusive',
          this.form.clientId = '',
          this.form.clientList = [],
          this.form.vendorTaxNumber = '',
          this.form.groupTripName = '',
          this.form.notes = '',
          this.form.fileId = null,
          this.form.cashAdvanceList = []
          this.form.cashAdvanceId = ''
          this.disabledTask =true
        this.fromExpensePage = false
        this.ifEdit = false
        this.projectTaskExpenseId = ''
        this.fileListEdit = []
        this.projectTaxId = ''
        this.isEmpty = false
        this.totalAmaunt = '0'
        this.totalTax = '0'
        this.form.projectListId = ''
        this.form.vendorListInput = ''
        this.taxObject = ''
      },
      openModal(state){
        const urlParts = this.buildUrl(state)
        this.labelName = urlParts.labelName
        this.activeState = state
        this.getActiveProject(this.$route.query.projectId || this.$route.query.engagementId || this.$route.query.businessUnitId, state)
        let loader = this.$loading.show();
        console.log('urlParts', urlParts)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.state}/directories?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${this.$route.query.projectId || this.$route.query.engagementId || this.$route.query.businessUnitId}&${urlParts.stateTaskId}=${this.selectedRow.id}&operation=create`)
          .then(response => {
            console.log('---', response.data);
            if(this.selectedRow.type === 'project' || this.selectedRow.type === 'Engagement'){
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post(`/api/v1/${urlParts.stateProjectTasks}/list?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${this.$route.query.projectId || this.$route.query.engagementId || this.$route.query.businessUnitId}`).then(response => {
                this.form.taskList = response.data.list
                loader.hide()
              }).catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
            }
            // this.getCurrency()
            this.form.paymentMethodList = response.data.projectTaskExpensePaymentMethod
            this.form.companyInventoryItem = response.data.companyInventoryItem
            this.form.clientList = response.data.companyClientList
            this.form.cashAdvanceList = response.data.projectTaskCashAdvance
            // this.form.vendorList = response.data.companyVendorList
            this.links = response.data.companyVendorList
            this.form.taxList = response.data.projectTaxList
            this.disabledInputs = false
            this.$refs.projectExpenseModal.open();
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      getActiveProject(projectId, state){
        const urlParts = this.buildUrl(state)
        axios
          .post(`/api/v1/${urlParts.routeName}/item?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}`)
          .then(response => {
            this.selectedProject = response.data.item
          }).catch(error => {
          console.log('An error occurred:', error);
        });
      },
      submitForm(form, state) {
        const urlParts = this.buildUrl(state)
        this.$refs[form].validate((valid) => {
          if (valid) {
              if(this.paymentMethodRadio === 'Payment'){
                this.form.cashAdvanceId = null
              }else if(this.paymentMethodRadio === 'CA'){
                this.form.paymentMethodId = null
              }
            let data = {
              projectTaskExpenseInventoryItemId: this.form.companyInventoryItemId,
              projectTaskExpensePaymentMethodId: this.form.paymentMethodId,
              companyVendorId: this.form.vendorListId,
              companyClientId: this.form.clientId,
              expenseDate: this.form.date,
              amount: Number(this.form.amount),
              totalAmount: Number(this.totalAmaunt),
              taxAmount: Number(this.totalTax) || null,
              projectTaxId: this.form.taxId,
              includeTax: "0",
              reimbursable: this.form.reimbursable,
              vendorTaxNo: this.form.vendorTaxNumber,
              group: this.form.groupTripName,
              notes: this.form.notes,
              isBillable: this.form.billable,
              fileId: this.form.fileId,
              projectTaskCashAdvanceId: this.form.cashAdvanceId || null
            }
            if(state === 'engagementTaskExpenses'){
              data['engagementCashAdvanceId'] = data['projectTaskCashAdvanceId'];
              delete data['projectTaskCashAdvanceId'];
            }else if(state === 'engagementTaskExpenses'){
              data['businessUnitCashAdvanceId'] = data['projectTaskCashAdvanceId'];
              delete data['projectTaskCashAdvanceId'];
            }

            if(this.form.ifTax === 'Tax Inclusive'){
              data.includeTax = false
            }else if(this.form.ifTax === 'Tax Exclusive'){
              data.includeTax = true
            }
            let taskId = 0
            if(this.selectedRow.type === 'project'){
              taskId = this.form.taskListId
            }else{
              taskId = this.$route.query.taskId
            }

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            let projectId = ''
            if(this.$route.name === 'expenses' || this.$route.name === 'users'){
              projectId = this.selectedProjectId
            }else if(this.$route.name === 'projects'){
              projectId = this.$route.query.projectId
            }else if(this.$route.name === 'engagements'){
              projectId = this.$route.query.engagementId
            }else if(this.$route.name === 'business-units'){
              projectId = this.$route.query.businessUnitId
            }
            axios
              .post(`/api/v1/${urlParts.state}/create?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}&${urlParts.stateTaskId}=${taskId || this.form.taskListId || 0}`, data)
              .then(response => {
                if(this.$route.name === 'expenses'){
                  this.$emit('setValueProject', this.form.projectListId);
                }else if(this.$route.name === 'users'){
                  this.$emit('setValueProject', this.form.projectListId)
                }
                this.$refs.projectExpenseModal.close();
                this.notification("Success", "Added Task Expense", "success");
              }).catch(error => {
              console.log('An error occurred:', error);
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      submitFormEdit(form, state) {
        const urlParts = this.buildUrl(state)
        this.$refs[form].validate((valid) => {
          if (valid) {
            if(this.paymentMethodRadio === 'Payment'){
              this.form.cashAdvanceId = null
            }else if(this.paymentMethodRadio === 'CA'){
              this.form.paymentMethodId = null
            }
            let data = {
              projectTaskExpenseInventoryItemId: this.form.companyInventoryItemId,
              projectTaskExpensePaymentMethodId: this.form.paymentMethodId,
              companyVendorId: this.form.vendorListId,
              companyClientId: this.form.clientId,
              expenseDate: this.form.date,
              amount: Number(this.form.amount),
              totalAmount: this.totalAmaunt,
              taxAmount: this.totalTax,
              projectTaxId: this.form.taxId,
              projectTaskId: this.form.taskListIdEdit,
              includeTax: "0",
              reimbursable: this.form.reimbursable,
              vendorTaxNo: this.form.vendorTaxNumber,
              group: this.form.groupTripName,
              notes: this.form.notes,
              isBillable: this.form.billable,
              fileId: this.form.fileId,
              projectTaskCashAdvanceId: this.form.cashAdvanceId
            }
            if(!data.fileId){
              data.fileId = null
            }
            if(this.form.ifTax === 'Tax Inclusive'){
              data.includeTax = false
            }else if(this.form.ifTax === 'Tax Exclusive'){
              data.includeTax = true
            }

            if(state === 'engagementTaskExpenses'){
              data['engagementCashAdvanceId'] = data['projectTaskCashAdvanceId'];
              data['engagementTaskId'] = data['projectTaskId'];
              delete data['projectTaskCashAdvanceId'];
              delete data['projectTaskId'];
            }else if(state === 'engagementTaskExpenses'){
              data['businessUnitCashAdvanceId'] = data['projectTaskCashAdvanceId'];
              data['businessUnitTaskId'] = data['projectTaskId'];
              delete data['projectTaskCashAdvanceId'];
              delete data['projectTaskId'];
            }
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            let projectId = ''
            if(this.$route.name === 'expenses' || this.$route.name === 'users'){
              projectId = this.selectedProjectId
            }else{
              projectId = this.$route.query.projectId
            }

            axios
              .post(`/api/v1/${urlParts.state}/update?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}&${urlParts.stateTaskId}=${this.form.taskListIdEdit || 0}&${urlParts.stateExpenseId}=${this.projectTaskExpenseId}`, data)
              .then(response => {
                if(this.$route.name === 'expenses'){
                  this.$emit('setValueProject', this.selectedProjectId);
                }else if(this.$route.name === 'users'){
                  this.$emit('setValueProject', this.selectedProjectId)
                }
                this.$refs.projectExpenseModal.close();
                this.notification("Success", "Edit Expense", "success");
              }).catch(error => {
              console.log('An error occurred:', error);
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      nestedChildOpen(url){
        this.fileUrl = url
        this.$refs.nestedChild.open();
        // alert(url)
      },
      removeFile(url){
        // this.form.fileId.splice(url, 1)
        this.form.fileId = ''
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      buildUrl(state) {
        let routeName = ''
        let labelName = ''
        let stateProjectId = ''
        let projectId = ''
        let stateTaskId = ''
        let taskId = ''
        let stateExpenseId = ''
        let stateProjectTasks = ''
        let cashAdvanceState = ''
        switch (state){
          case 'projectTaskExpenses':
            routeName = 'projects'
            labelName = 'Project'
            stateProjectId = 'projectId'
            stateProjectTasks = 'projectTasks'
            stateTaskId = 'projectTaskId'
            stateExpenseId = 'projectTaskExpenseId'
            cashAdvanceState = 'projectTasksCashAdvance'
            break;
          case 'engagementTaskExpenses':
            routeName = 'engagements'
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTasks = 'engagementTasks'
            stateExpenseId = 'engagementTaskExpenseId'
            labelName = 'Engagement'
            cashAdvanceState = 'engagementTasksCashAdvance'
            break;
          case 'businessUnitTaskExpenses':
            routeName = 'businessUnits'
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTasks = 'businessUnitTasks'
            stateExpenseId = 'businessUnitTaskExpenseId'
            labelName = 'Business Unit'
            cashAdvanceState = 'businessUnitTasksCashAdvance'
            break;
          case 'requestProjectTaskExpenses':
            routeName = 'projects'
            labelName = 'Project'
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateProjectTasks = 'projectTasks'
            stateExpenseId = 'projectTaskExpenseId'
            cashAdvanceState = 'requestProjectTasksCashAdvance'
            break;
          case 'requestEngagementTaskExpenses':
            routeName = 'engagements'
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTasks = 'engagementTasks'
            stateExpenseId = 'engagementTaskExpenseId'
            labelName = 'Engagement'
            cashAdvanceState = 'requestEngagementTasksCashAdvance'
            break;
          case 'requestBusinessUnitTaskExpenses':
            routeName = 'businessUnits'
            stateProjectId = 'businessUnitId'
            stateProjectTasks = 'businessUnitTasks'
            stateTaskId = 'businessUnitTaskId'
            stateExpenseId = 'businessUnitTaskExpenseId'
            labelName = 'Business Unit'
            cashAdvanceState = 'requestBusinessUnitTasksCashAdvance'
            break;
        }
        return {
          state: state,
          routeName: routeName,
          stateProjectId: stateProjectId,
          labelName: labelName,
          projectId: projectId,
          stateTaskId: stateTaskId,
          stateProjectTasks: stateProjectTasks,
          taskId: taskId,
          stateExpenseId: stateExpenseId,
          cashAdvanceState: cashAdvanceState
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
    .project-expense-modal {
        &__title {
            text-align: center;
        }
        &__btn {
            text-align: center;
        }
        .form-row{
            display:flex;
            justify-content:space-around;
        }
        &__form{

        }
        .el-form-item {
            margin-bottom: 18px;
        }
        /deep/.el-form-item__label{
            line-height:18px;
        }
        /deep/.el-form-item__content{
            line-height:18px;
        }
        /*.el-select {*/
            /*display: block;*/
        /*}*/
        .el-date-editor{
            width:100%;
        }
        /*.inclusive-btn{*/
            /*margin-bottom:18px;*/
        /*}*/
        /deep/.el-input.is-disabled .el-input__inner{
            color: #404348;
        }
    }
    .amount-input{
        /deep/.el-input__inner{
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
    }
    .amount-currency{
        /deep/.el-input__inner{
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }
    .iframe{
        width:640px;
        height:700px;
    }
    .sweet-modal-overlay{
        z-index:1000;
    }
    /deep/.el-autocomplete{
        width:100%;
        .el-input-group__append{
            background-color: #ecf5ff;
            color: #409EFF;
            border-color: #b3d8ff;
            &:hover{
                background: #409EFF;
                border-color: #409EFF;
                color: #FFF;
            }
        }
        /*.el-input__suffix{*/
        /*right:0;*/
        /*.add-btn{*/

        /*}*/
        /*i{*/
        /*display:none;*/
        /*}*/
        /*}*/
    }
    .col{
        margin-left:50%;
    }
</style>

<style>

</style>
